import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ProgressBar } from 'react-bootstrap';
import ImportStatus from '../import_status';

export class Revert extends React.Component {
  static propTypes = {
    importStatus: PropTypes.number.isRequired
  }

  renderProgressBar() {
    const { importStatus } = this.props;

    return (
      <div className="panel panel-default">
        <div className="p-5">
          <div className="h2 semibold mt-0">Reverting Import</div>
          <div className="larger-text mb-4">
            The system is processing your revert.
            This page will update when the revert is done
          </div>
          <ProgressBar label={`${importStatus}%`} now={importStatus}/>
        </div>
        <ImportStatus importStatus={["reverted", "complete"]} />
      </div>
    );
  }

  render() {
    return (
      <div className="container step-container revert">
        {this.renderProgressBar()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  importStatus: state.ui.importStatus,
});

export default connect(mapStateToProps)(Revert);